import React, { useEffect, useState } from "react";
import "firebase/auth";
import Auth from "../../api/auth";
import { Spin } from "antd";

import { Redirect } from "react-router-dom";

const SignOut = () => {
  const [loggedOut, setLoggedOut] = useState(false);

  useEffect(() => {
    async function signOut() {
      await Auth.signOut();
      setLoggedOut(true);
    }
    signOut();
  }, []);

  return loggedOut ? <Redirect to="/login" /> : <Spin />;
};

export default SignOut;
